import { ChangeType, Contact, FinancialVendorAddress, FinancialVendorStatus } from "./index";

export class FinancialVendor {
    id: number;
    name: string;
    businessAsName: string;
    tpLawsonId: string;
    marketId: number;
    TaxId: number;
    IsActiveFinancial: boolean;
    vendorId: number;
    financialVendorStatusId: FinancialVendorStatus;
    financialVendorAddresses: FinancialVendorAddress[];
    financialVendorContacts: Contact[];
    lastUsedDate: Date;
    isActivePurchaseOrder: boolean;
    requireInvoiceNumber: boolean;
    changeType: ChangeType;
    displayText: string;
}
